import React from 'react'
import styled from 'styled-components'
import Link from '../Link'
import constants from '../../constants/constants'
import social from '../../constants/social'
import styles from '../../constants/styles'
import colors from '../../constants/colors'
import OptimizedImage from '../shared/OptimizedImage'

const column1 = [
  { title: 'About', path: 'https://impact.abillion.com/about' },
  { title: 'Careers', path: 'https://impact.abillion.com/careers' },
  { title: 'Press', path: `${constants.webURL}/press` },
  { title: 'Contact', path: `${constants.webURL}/contact` }
]

const column2 = [
  { title: 'Awards', path: 'https://www.awards.abillion.com/' },
  {
    title: 'Business',
    path: 'https://business.abillion.com/?utm_source=footerWeb'
  },
  { title: 'Data', path: 'https://www.data.abillion.com/' }
]

const column3 = [
  {
    title: 'Community Guidelines',
    path: `${constants.webURL}/policies/community`
  },
  {
    title: 'Privacy Policy',
    path: `${constants.webURL}/policies/privacy`
  },
  { title: 'Terms of Use', path: `${constants.webURL}/policies/terms` },
  {
    title: 'Copyright Dispute Policy',
    path: `${constants.webURL}/policies/copyright`
  }
]

const Footer = () => (
  <Container>
    <Left>
      <Link href="/" underline="none">
        <Logo
          size="160"
          src="../../static/abillion-logo-white.png"
          alt="abillion logo"
          title="abillion logo"
        />
      </Link>

      <Section>
        <ul>
          {column1.map((p) => (
            <SectionItem key={p.title}>
              <ClaimExternalLink href={p.path} target="_blank">
                <InfoLink>{p.title}</InfoLink>
              </ClaimExternalLink>
            </SectionItem>
          ))}
        </ul>
      </Section>

      <Section>
        <ul>
          {column2.map((p) => (
            <SectionItem key={p.title}>
              <ClaimExternalLink href={p.path} target="_blank">
                {p.title}
              </ClaimExternalLink>
            </SectionItem>
          ))}
        </ul>
      </Section>

      <Section>
        <ul>
          {column3.map((p) => (
            <SectionItem key={p.title}>
              <ClaimExternalLink href={p.path} target="_blank">
                <InfoLink>{p.title}</InfoLink>
              </ClaimExternalLink>
            </SectionItem>
          ))}
        </ul>
      </Section>
    </Left>

    <Right>
      <span style={{ fontSize: '14px' }}>
        Start exploring, download the app!
      </span>

      <DownloadActionContainer>
        <AppStoreDiv
          href="https://abillion.onelink.me/Xkww/ojj50e8w"
          target="_blank"
          rel="noopener noreferrer"
        >
          <AppStoreImage
            size="sm"
            src="https://res.cloudinary.com/abillionveg/image/upload/v1621841747/web/AppStoreDownload.svg"
            alt="Available on the App Store"
            title="Available on the App Store"
            loading="lazy"
          />
        </AppStoreDiv>

        <AppStoreDiv
          href="https://abillion.onelink.me/Xkww/ojj50e8w"
          target="_blank"
          rel="noopener noreferrer"
        >
          <AppStoreImage
            size="sm"
            src="https://res.cloudinary.com/abillionveg/image/upload/v1621841747/web/GooglePlayDownload.svg"
            alt="Get it on Google Play"
            title="Get it on Google Play"
            loading="lazy"
          />
        </AppStoreDiv>
      </DownloadActionContainer>

      <SocialMedia>
        {social.slice(0, 4).map((s, i) => (
          <SocLink
            index={i}
            key={s.type}
            href={s.link}
            title={s.title}
            target="_blank"
            rel="noopener noreferrer"
          >
            {s.icon}
          </SocLink>
        ))}
        <Copyright>{`© abillion ${new Date().getFullYear()}`}</Copyright>
      </SocialMedia>
    </Right>
  </Container>
)

export default Footer

const Container = styled.footer`
  width: 100%;
  padding: 32px;
  display: none;
  justify-content: space-between;
  background-color: ${colors.liquorice[100]};
  color: ${styles.colors.white};
  @media (min-width: 900px) {
    display: flex;
  }
`

const Left = styled.section`
  width: 70%;
  display: flex;
  align-items: flex-start;
`

const Right = styled.section`
  width: 30%;
  text-align: right;
`

const Logo = styled(OptimizedImage)`
  width: 30%;
  min-width: 160px;
  object-fit: contain;
`

const Section = styled.section`
  margin: 0 16px;
  padding: 0 16px;
`

const SectionItem = styled.li`
  font-size: 14px;
  padding-top: ${styles.padding.medium};
`

const ClaimExternalLink = styled.a`
  text-decoration: none;
  font-size: 1em;
  color: ${styles.colors.white};
  &:hover {
    border-bottom: 2px solid ${styles.colors.white};
  }
`
const InfoLink = styled.span`
  text-decoration: none;
  font-size: 1em;
  color: ${styles.colors.white};
  &:hover {
    border-bottom: 2px solid ${styles.colors.white};
  }
`

const SocialMedia = styled.ul`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

const SocLink = styled.a`
  text-decoration: none;
  font-size: ${(props) => (props.isFirst ? '1.8em' : '2em')};
  color: ${styles.colors.white};
  margin-right: ${(props) => (props.index === 3 ? 0 : styles.margin.large)};
  display: flex;
  align-items: center;
`

const Copyright = styled.span`
  font-size: 14px;
`

const DownloadActionContainer = styled.div`
  display: flex;
  margin: ${styles.margin.large} 0;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: 800px) {
    flex-direction: column;
  }
  @media (max-width: 600px) {
    flex-direction: row;
    margin-top: ${styles.margin.large};
  }
  @media (max-width: 400px) {
    flex-direction: column;
  }
`
const AppStoreDiv = styled.a`
  width: 160px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: ${styles.margin.large};
`

const AppStoreImage = styled(OptimizedImage)`
  max-width: 100%;
  height: auto;
  object-fit: cover;
`
